import React, { useEffect, useState } from "react";
import questions from "../../utils/QuestionSection";
import { authorizedGet, authorizedPost } from "../../Config/networkWithToken";
import configuration from "../../Config/configuration";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import html2pdf from "html2pdf.js";
import Spinner from "../Spinner/Spinner";
import MessageBar, {
  config,
  errorNotify,
  successNotify,
} from "../../utils/helper";
import { useLocation } from "react-router-dom";
import RejectModel from "../RejectModel/RejectModel";

const ViewQuestionnaireAnswers = ({
  userId,
  requestedUserId,
  questionnaireData,
  userData,
}) => {
  const [mergedQAData, setMergedQAData] = useState({});
  const [completionPercentage, setCompletionPercentage] = useState(0);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isAcceptedLoading, setIsAcceptedLoading] = useState(false);
  const [isRejectedLoading, setIsRejectedLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(null);
  const [requestLoading, setRequestLoading] = useState(false);
  const [horoscopeChecked, setHoroscopeChecked] = useState(false);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const localStorageUserData = JSON.parse(localStorage.getItem("userData"));
  const userRole = localStorageUserData?.role;
  const [mutualApprovalStatus, setMutualApprovalStatus] = useState(
    questionnaireData?.[0]?.mutualApproval,
  );
  const [finalAgreeChecked, setFinalAgreeChecked] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    if (
      questionnaireData?.[0]?.adminApproval === "pending" ||
      questionnaireData?.[0]?.adminApproval === "approved"
    ) {
      setHoroscopeChecked(true);
      setFinalAgreeChecked(true);
    }
  }, []);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setHoroscopeChecked(isChecked);
  };
  const handleIsAgreeCheckboxChange = (e) => {
    const agreeChecked = e.target.checked;
    setFinalAgreeChecked(agreeChecked);
  };

  const handleSentRequest = async () => {
    if (!horoscopeChecked) {
      errorNotify("Please check the horoscope before sending the request.");
      return;
    }
    if (!finalAgreeChecked) {
      errorNotify("Please check the questionaire before sending the request.");
      return;
    }
    setRequestLoading(true);
    try {
      const data = {
        userId: userId,
        requestedUserId: requestedUserId,
        horoscope: true,
        isAgreed: true,
      };
      const res = await authorizedPost(
        configuration.apis.sendApproval,
        data,
        config,
      );
      const response = res?.data;
      if (response?.status) {
        successNotify(response?.message);
        setButtonStatus("Pending.....!");
      } else {
        errorNotify(response?.message);
      }
    } catch (error) {
      console.log(error);
      errorNotify("Unexpected Error");
    } finally {
      setRequestLoading(false);
    }
  };
  const handleAction = async (decision) => {
    if (decision === "approve") {
      setIsAcceptedLoading(true);
    } else {
      setIsRejectedLoading(true);
    }

    try {
      const data = {
        reqId: questionnaireData?.[0]?._id,
        action: decision,
        comments: comment,
      };
      const res = await authorizedPost(
        configuration.apis.overAllApproval,
        data,
        config,
      );

      if (res?.data?.status) {
        successNotify(res?.data?.message);
        if (decision === "approve") {
          setButtonStatus("approved");
          setMutualApprovalStatus("approved");
        }
        if (decision === "reject") {
          setButtonStatus("rejected");
        }
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      errorNotify("Error processing request.");
    } finally {
      setIsAcceptedLoading(false);
      setIsRejectedLoading(false);
      setIsBlocked(false);
    }
  };

  const handleDeny = () => {
    setIsCommentSectionOpen(true);
  };

  const handleNoteChange = (event) => {
    setError(false);
    setComment(event.target.value);
  };

  const closeModal = () => {
    setComment("");
    setError(false);
    setIsCommentSectionOpen(false);
  };

  const handleSaveComment = () => {
    if (comment.length < 15) {
      setError(true);
    } else {
      handleAction("reject");
      setIsCommentSectionOpen(false);
      setError(false);
      setComment("");
    }
  };

  const location = useLocation();
  const pathName = location.pathname;
  const getPath = pathName.split("/");

  useEffect(() => {
    fetchAnswers();
  }, [questions, userId]);

  const fetchAnswers = async () => {
    try {
      setLoading(true);
      const response = await authorizedGet(
        `${configuration.apis.getAnswers}?userId=${userId}`,
      );

      if (response?.data?.status) {
        const answerData = response.data.data;
        setCompletionPercentage(answerData.completionPercentage || 0);

        const answerMap = {};
        answerData.answers.forEach((section) => {
          answerMap[section.sectionId] = {};
          section.questions.forEach((q) => {
            answerMap[section.sectionId][q.id] = q.answer;
          });
        });
        const combinedData = Object.entries(questions).map(
          ([sectionId, section]) => {
            const answers = answerMap[sectionId] || {};
            return {
              sectionId,
              title: section.title,
              questions: section.questions.map((q) => ({
                ...q,
                answer: answers[q.id] || "N/A",
              })),
            };
          },
        );

        setMergedQAData(combinedData);
      }
    } catch (error) {
      console.error("Error fetching answers:", error);
    } finally {
      setLoading(false);
    }
  };

  const currentSection = mergedQAData[currentSectionIndex];

  const handleNext = () => {
    console.log("next");

    if (currentSectionIndex < mergedQAData?.length - 1) {
      setCurrentSectionIndex((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (currentSectionIndex > 0) {
      setCurrentSectionIndex((prev) => prev - 1);
    }
  };
  const handleDownloadAllPDF = () => {
    const element = document.getElementById("Questionnaire-Section");
    const fileName = `${userData.name}-questionnaire-${userId}.pdf`;
    // Temporarily show hidden div
    element.style.display = "block";
    element.style.position = "static";
    element.style.opacity = "1";

    // Apply optional styling tweaks
    element.style.padding = "20px";
    element.style.fontFamily = "Arial, sans-serif"; // Font

    // Generate PDF
    html2pdf()
      .from(element)
      .set({
        filename: fileName,
        margin: [10, 10, 15, 10], // top, left, bottom, right in mm
        jsPDF: { unit: "mm", format: "a4" },
        pagebreak: { mode: ["css", "legacy"] },
      })
      .save()
      .finally(() => {
        element.style.opacity = "0";
        element.style.display = "none";
      });
    setDownloading(true);
    setDisabled(true);
    setTimeout(() => {
      setDownloading(false);
      setDisabled(false);
    }, 2000);
  };

  return (
    <div className="flex flex-wrap justify-center gap-4 p-4 md:justify-start">
      {/* Checkboxes for non-admin and not in accepted-users route */}
      {userRole === "user" && getPath[1] !== "accepted-users" && (
        <>
          <label className="mb-2 flex items-center">
            <input
              type="checkbox"
              className="mr-2"
              checked={horoscopeChecked}
              onChange={handleCheckboxChange}
            />
            I have successfully completed my horoscope, thoroughly analyzing my
            birth chart and astrological details or not interested in matching
            horoscope.
          </label>

          <label className="mb-2 flex items-center">
            <input
              type="checkbox"
              className="mr-2"
              checked={finalAgreeChecked}
              onChange={handleIsAgreeCheckboxChange}
            />
            I agree to share the information provided in my questionnaire with
            other users for review and compatibility purposes.
          </label>
        </>
      )}

      <div className="w-full">
        {loading ? (
          <div className="flex min-h-screen flex-col items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <div className="space-y-8 p-6">
            {Object.keys(mergedQAData)?.length === 0 ? (
              <div className="py-10 text-center font-semibold text-red-600">
                No answer data available for this user.
              </div>
            ) : (
              <>
                {userRole === "user" &&
                questionnaireData?.[0]?.adminApproval !== "approved" ? (
                  <div className="py-10 text-center font-semibold text-red-600">
                    Note : This section is not available until your Questionarie
                    is fully approved.
                  </div>
                ) : (
                  <div>
                    <div className="text-right text-lg font-semibold text-green-600">
                      Overall Completion: {completionPercentage}%
                    </div>

                    <div className="flex w-full justify-end p-3">
                      {(userRole === "admin" || userRole === "superAdmin") && (
                        <button
                          onClick={handleDownloadAllPDF}
                          disabled={disabled}
                          className="flex items-center gap-2 rounded-full bg-textYellow px-6 py-2 font-medium text-white"
                        >
                          {downloading ? "Downloading..." : "Download"}
                        </button>
                      )}
                    </div>

                    <div className="rounded-lg border bg-white p-6 shadow">
                      <h2 className="mb-4 text-2xl font-bold text-textYellow">
                        Section {currentSectionIndex + 1}:{" "}
                        {currentSection?.title}
                      </h2>

                      {currentSection?.questions.map((q) => (
                        <div key={q?.id} className="mb-4">
                          <p className="font-semibold text-gray-800">
                            {q?.id}. {q?.question}
                          </p>
                          <p className="text-gray-700">
                            Answer:{" "}
                            <span className="font-medium text-black">
                              {(() => {
                                if (
                                  typeof q?.answer === "object" &&
                                  q?.answer !== null
                                ) {
                                  let parts = [];

                                  // If q.answer is an array → simple case
                                  if (Array.isArray(q.answer)) {
                                    parts.push(q.answer.join(", "));
                                  } else {
                                    const entries = Object.entries(
                                      q.answer,
                                    ).filter(
                                      ([, val]) =>
                                        val !== null &&
                                        val !== undefined &&
                                        !(
                                          Array.isArray(val) && val.length === 0
                                        ) &&
                                        !(
                                          typeof val === "string" &&
                                          val.trim() === ""
                                        ),
                                    );

                                    let selectedValues = [];
                                    let otherParts = [];

                                    // Added variable holders
                                    let optionValue = "";
                                    let subSelectionValue = "";
                                    let othersTextValue = "";

                                    entries.forEach(([key, val]) => {
                                      // Collect array values except "Others"
                                      if (Array.isArray(val)) {
                                        selectedValues.push(
                                          ...val.filter(
                                            (v) =>
                                              v !== "Others" && v.trim() !== "",
                                          ),
                                        );
                                      } else if (
                                        key.toLowerCase() === "option"
                                      ) {
                                        optionValue = val;
                                      } else if (
                                        key.toLowerCase() === "subselection"
                                      ) {
                                        subSelectionValue = val;
                                      } else if (
                                        key.toLowerCase().includes("others")
                                      ) {
                                        othersTextValue = val;
                                      } else {
                                        otherParts.push(
                                          `${key.charAt(0).toUpperCase() + key.slice(1)}: ${val}`,
                                        );
                                      }
                                    });

                                    //  Added: Format special Option/SubSelection/Others cases
                                    if (optionValue) {
                                      if (
                                        optionValue === "Others" &&
                                        othersTextValue
                                      ) {
                                        // We'll handle "Others" separately later (to move it last)
                                        otherParts.push(
                                          `Others: ${othersTextValue}`,
                                        );
                                      } else if (subSelectionValue) {
                                        selectedValues.push(
                                          `${optionValue}, ${subSelectionValue}`,
                                        );
                                      } else {
                                        selectedValues.push(optionValue);
                                      }
                                    } else if (othersTextValue) {
                                      otherParts.push(
                                        `Others: ${othersTextValue}`,
                                      );
                                    }

                                    // Combine previous selected + other parts
                                    if (selectedValues.length > 0)
                                      parts.push(selectedValues.join(", "));
                                    if (otherParts.length > 0)
                                      parts.push(otherParts.join(", "));
                                  }

                                  return `${parts.join(", ")}`;
                                } else {
                                  return q?.answer ? `${q.answer}` : "N/A";
                                }
                              })()}
                            </span>
                          </p>
                        </div>
                      ))}
                      <div className="flex justify-between pt-6">
                        <button
                          onClick={handleBack}
                          disabled={currentSectionIndex === 0}
                          className={`flex items-center gap-2 rounded-full px-5 py-2 text-sm font-medium transition-all duration-200 ${
                            currentSectionIndex === 0
                              ? "cursor-not-allowed bg-gray-200 text-gray-400"
                              : "border border-gray-300 bg-white text-gray-700 hover:bg-gray-100"
                          }`}
                        >
                          <FaArrowLeft /> Back
                        </button>

                        <button
                          onClick={handleNext}
                          disabled={
                            mergedQAData?.length === currentSectionIndex + 1
                          }
                          className={`flex items-center gap-2 rounded-full bg-textYellow px-6 py-2 font-medium text-white shadow transition ${
                            mergedQAData?.length === currentSectionIndex + 1
                              ? "cursor-not-allowed bg-textYellow/50 text-white"
                              : " bg-textYellow text-white hover:bg-yellow-700"
                          }`}
                        >
                          Next <FaArrowRight />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {/* Approval buttons or request flow */}
                {questionnaireData?.[0]?.adminApproval !== "approved" &&
                userRole === "user" ? (
                  <div className="flex flex-col items-center justify-center gap-2">
                    {(questionnaireData?.[0]?.adminApproval === "pending" ||
                      questionnaireData?.[0]?.adminApproval === "rejected" ||
                      buttonStatus) && (
                      <button className="z-40 rounded-md bg-textYellow px-10 py-2 text-white">
                        {buttonStatus === null ? (
                          <p>{questionnaireData?.[0]?.adminApproval}.....!</p>
                        ) : (
                          <p>{buttonStatus}</p>
                        )}
                      </button>
                    )}

                    {(questionnaireData?.[0]?.adminApproval !== "rejected") &&
                      !buttonStatus && (
                        <>
                          <button
                            onClick={handleSentRequest}
                            className={`z-40 rounded-md bg-textYellow px-10 py-2 text-white ${
                              !(horoscopeChecked && finalAgreeChecked)
                                ? "cursor-not-allowed opacity-50"
                                : ""
                            }`}
                            disabled={!(horoscopeChecked && finalAgreeChecked)}
                          >
                            {requestLoading ? (
                              <Spinner />
                            ) : (
                              "Questionnaire Request"
                            )}
                          </button>
                          <p className="text-xs text-red-600">
                            Note: Raise Request to see the Questionnaire
                          </p>
                        </>
                      )}
                  </div>
                ) : null}
                {questionnaireData?.[0]?.adminApproval === "approved" &&
                  getPath[1] !== "accepted-users" && (
                    <>
                      {questionnaireData?.[0]?.otherUsersApproval?.status ===
                        "rejected" ||
                      mutualApprovalStatus === "rejected" ||
                      buttonStatus === "rejected" ? (
                        <div>
                          <button className="flex items-center justify-center rounded-sm bg-red-600 p-2 text-white">
                            Request Was Declined
                          </button>
                        </div>
                      ) : (
                        <div className="flex w-full items-center justify-around">
                          {mutualApprovalStatus === "approved" ? (
                            <button
                              disabled
                              className="cursor-not-allowed rounded bg-green-600 px-4 py-2 text-white"
                            >
                              Approved
                            </button>
                          ) : (
                            <>
                              <button
                                onClick={() => handleAction("approve")}
                                disabled={isAcceptedLoading}
                                className="rounded bg-green-500 px-4 py-2 text-white hover:bg-green-600"
                              >
                                {isAcceptedLoading ? "Approving..." : "Accept"}
                              </button>
                              <button
                                onClick={handleDeny}
                                disabled={isRejectedLoading}
                                className="rounded bg-red-500 px-4 py-2 text-white hover:bg-red-600"
                              >
                                {isRejectedLoading ? "Declining..." : "Deny"}
                              </button>
                            </>
                          )}
                        </div>
                      )}
                    </>
                  )}
              </>
            )}
          </div>
        )}
      </div>

      {/* Rejection comment modal */}
      {isCommentSectionOpen && (
        <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <RejectModel
            setComment={setComment}
            comment={comment}
            handleNoteChange={handleNoteChange}
            closeModal={closeModal}
            error={error}
            handleSaveComment={handleSaveComment}
            setIsBlocked={setIsBlocked}
            isShowDropdown={false}
          />
        </div>
      )}
      <div
        id="Questionnaire-Section"
        style={{
          display: "none",
          opacity: "0",
        }}
      >
        {mergedQAData.length > 0 &&
          mergedQAData.map((section, idx) => (
            <div
              key={section.sectionId}
              style={{ marginBottom: "30px", pageBreakAfter: "always" }}
            >
              <h2 className="mb-4 text-2xl font-bold text-textYellow">
                Section {idx + 1}: {section.title}
              </h2>

              {section.questions.map((q) => (
                <div className="py-2 font-semibold text-gray-800">
                  {/* QUESTION — one line */}
                  <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
                    {q.id}. {q.question}
                  </p>

                  {/* ANSWER — next line */}
                  <p className="py-2 font-medium text-black">
                    {typeof q.answer === "object" && q.answer !== null
                      ? Array.isArray(q.answer)
                        ? q.answer.join(", ")
                        : Object.entries(q.answer)
                            .map(
                              ([key, val]) =>
                                `${key}: ${
                                  Array.isArray(val) ? val.join(", ") : val
                                }`,
                            )
                            .join("; ")
                      : q.answer || "N/A"}
                  </p>
                </div>
              ))}
            </div>
          ))}
      </div>

      <MessageBar />
    </div>
  );
};

export default ViewQuestionnaireAnswers;
